module.exports = __webpack_public_path__ + "static/icons/icon-schedule-c18494cbe2efbce1a1d7c677e624a7ab.svg";